import React, { useEffect, useContext } from "react";
import { TransakConfig, Transak } from "@transak/transak-sdk";
import useState from "react-usestateref";
import { toast } from "react-toastify";
import { Trasnsac_key } from "../core/config";
import { useTranslation } from "react-i18next";
import { getUserDetails } from "../services/authservices";
import service from "../services/authservices";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
const Widget = ({
  fromCurrency,
  toCurrency,
  email,
  walletAddress,
  fiatAmount,
  network,
}) => {
  const { t } = useTranslation();
  const [toastId, setToastId] = useState(null);
  const [user, setUser] = useState({
    uid: null,
  });
  const [transactionDetatils, settransactionDetatils] = useState();
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [toastVisible, setToastVisible] = useState(false);

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            uid: data.uid,
          };
          setUser(userDetails);
        } else {
          setUser({
            uid: null,
          });
        }
      } catch (error) {
        setUser({
          uid: null,
        });
      }
    } else {
      setUser({
        uid: null,
      });
    }
    setLoading(false);
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false),
          autoClose: 3000,
        }
      );
    }
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false),
          autoClose: 3000,
        }
      );
    }
  };

  const navigate = useNavigate();

  const openTransak = async () => {
    try {
      setLoader(true);
      const transak = new Transak({
        apiKey: Trasnsac_key.transct_key,
        environment: Trasnsac_key.environment,
        cryptoCurrencyCode: fromCurrency,
        walletAddress: walletAddress,
        themeColor: "ffffff",
        fiatCurrency: toCurrency,
        fiatAmount: fiatAmount,
        paymentMethod: "credit_debit_card",
        network: network,
        disableWalletAddressForm: true,
        partnerOrderId: `${user.uid}`,
        partnerCustomerId: `${user.uid}`,
        disableFiatCurrency: true,
        disableCryptoCurrency: true,
        disableEmail: false,
        isKycEditable: true,
        colorMode: "DARK",
      });
      transak.init();
      // console.log(Transak, "Transak");

      Transak.on("*", (data) => {});

      Transak.on(Transak.EVENTS.TRANSAK_WIDGET_CLOSE, () => {
        transak.close();
        transak.cleanup();
        setLoader(false);
      });

      Transak.on(Transak.EVENTS.TRANSAK_ORDER_CREATED, (orderData) => {});

      Transak.on(Transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, async (orderData) => {
        console.log(orderData, "orderData=====");
        if (orderData.eventName == "TRANSAK_ORDER_SUCCESSFUL") {
          transak.close();
          settransactionDetatils(orderData.status);
          var Order_obj = {
            ipAddress: orderData.status.ipAddress,
            TransationId:
              orderData.status.TransationId ||
              "0x32d51249d0467cfea5f48cae008db9ab9fb6bc76b78d1e83fcccf66bc07a94232",
            TransationHash: orderData.status.TransationHash || "DUMMY_TX_ID",
            walletAddress: orderData.status.walletAddress,
            orderId: orderData.status.id,
            fiatCurrency: orderData.status.fiatCurrency,
            cryptoCurrency: orderData.status.cryptoCurrency,
            type: orderData.status.type || "COMPLETED",
            fiatAmount: orderData.status.fiatAmount,
            amountPaid: orderData.status.amountPaid,
            paymentOptionId: orderData.status.paymentOptionId,
            cryptoAmount: orderData.status.cryptoAmount,
            email: email,
          };

          var resp = await service.saveTransaction(Order_obj);
          if (resp.status == true) {
            setLoader(false);
            showSuccessToast(resp.Message);
            navigate("/history");
          } else {
            setLoader(false);
            showErrorToast(resp.Message);
          }
          setLoader(false);
        } else {
          transak.close();
          setLoader(false);
        }

        if (orderData.eventName === "TRANSAK_ORDER_SUCCESSFUL") {
          showSuccessToast("Transaction Processing...");
          transak.close();
          setLoader(false);
          navigate("/history");
        } else {
          transak.close();
          setLoader(false);
        }
      });
    } catch (err) {}
  };

  return (
    <>
      {loader ? (
        <div className="reg_btn">
          <span className="hero_invest"> {t("Loading")} </span>
        </div>
      ) : (
        <div onClick={openTransak}> {t("BuyWithCard")}</div>
      )}
    </>
  );
};
export default Widget;
